import moment, { type Moment } from 'moment';
import 'moment-timezone';

// Converts the date input to a Moment object, while also accounting for the timezone
export function toMoment(date: unknown): Moment | null {
  if (date == null) {
    return null;
  }

  if (moment.isMoment(date)) {
    return date as Moment;
  }

  if (typeof date === 'object' && date !== null && 'date' in date) {
    const block = date as { date: unknown; timezone?: unknown };
    const raw = block.date;
    if (raw == null || raw === '') {
      return null;
    }
    const tz = block.timezone;
    if (typeof tz === 'string' && tz.trim() !== '') {
      return moment.tz(String(raw), tz).local();
    }
    return moment(String(raw));
  }

  if (typeof date === 'string') {
    if (date === '') {
      return null;
    }
    return moment(date);
  }

  return moment(date);
}

export function formatDate(date: unknown, formatString: string): string;
export function formatDate(date: unknown, includeTime?: boolean): string;
export function formatDate(date: unknown, includeTimeOrFormat: boolean | string = true): string {
  const parsed = toMoment(date);
  if (parsed == null || !parsed.isValid()) {
    return '';
  }

  if (typeof includeTimeOrFormat === 'string') {
    return parsed.format(includeTimeOrFormat);
  }

  if (includeTimeOrFormat) {
    return parsed.format('YYYY/MM/DD HH:mm:ss');
  }

  return parsed.format('YYYY/MM/DD');
}

export const DateTime = (props: { value: unknown }) =>
  <span>{formatDate(props.value)}</span>;
